import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VendorLocation {
  name: string;
  locationId: string;
}

interface CarrierOption {
  value: string;
  display: string;
  image?: string;
  d365AccountDisplayValue?: string;
  vendorLocationMap: VendorLocation[];
}

interface CarrierState {
  carrierOptions: CarrierOption[];
  loading: boolean;
}

const initialState: CarrierState = {
  carrierOptions: [],
  loading: false,
};

const carrierSlice = createSlice({
  name: 'purchaseCarrier',
  initialState,
  reducers: {
    setCarrierOptions: (state, action: PayloadAction<CarrierOption[]>) => {
      state.carrierOptions = action.payload;
    },
    clearCarrierOptions: state => {
      state.carrierOptions = [];
    },
  },
});

export const { setCarrierOptions, clearCarrierOptions } = carrierSlice.actions;

export default carrierSlice.reducer;
